import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import axiosAPI from '../axiosAPI';

/**
 * Hook para gerenciar o perfil do usuário
 */
export const useUserProfile = () => {
  const queryClient = useQueryClient();

  // Query para buscar dados do perfil
  const { data: profile, isLoading, error } = useQuery({
    queryKey: ['userProfile'],
    queryFn: async () => {
      const { data } = await axiosAPI.get('/user/profile');
      return data;
    },
    retry: 1
  });

  // Mutation para atualizar o perfil
  const updateProfileMutation = useMutation({
    mutationFn: async (profileData) => {
      const { data } = await axiosAPI.post('/user/profile', profileData);
      return data;
    },
    onSuccess: (data) => {
      // Invalida o cache para recarregar os dados
      queryClient.invalidateQueries({ queryKey: ['userProfile'] });
      toast.success('Perfil atualizado com sucesso!');
    },
    onError: (error) => {
      const message = error.response?.data?.message || 'Erro ao atualizar perfil';
      toast.error(message);
    }
  });

  return {
    profile,
    isLoading,
    error,
    updateProfile: updateProfileMutation.mutate,
    isUpdating: updateProfileMutation.isPending
  };
};

// Hook antigo mantido para compatibilidade
export const useUsersProfile = () => {
  const query = useQuery({
    queryKey: ['userProfile'],
    queryFn: async () => {
      const res = await axiosAPI.get('auth/user-profile');
      return res.data;
    }
  });

  return {
    user: query.data,
    isLoading: query.isLoading,
    isError: query.error,
    isFetching: query.isFetching
  };
};